import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {FC, useCallback, useState} from 'react';
import {useLocation} from 'react-router';

import history from '../../../../../util/history';
import {useDebouncedValue} from '../../../../../util/useDebouncedValue';
import {SettingTitle} from '../common/SettingTitle';
import {MediaSettingProps} from '../types';

export const ChartTitle: FC<MediaSettingProps> = ({updateConfig, config}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Debounce the updateConfig call while the user is typing
  const updateChartTitle = useCallback(
    (chartTitle: string) => {
      updateConfig({chartTitle});
      const panelDisplayName = searchParams.get('panelDisplayName');
      // Update the URL for the panel display name if on a specific run page
      if (
        panelDisplayName &&
        panelDisplayName !== chartTitle &&
        chartTitle !== ''
      ) {
        searchParams.set('panelDisplayName', chartTitle);
        history.replace(`${location.pathname}?${searchParams.toString()}`);
      }
    },
    // If we rely on searchParams, updateConfig will be called on every keystroke
    // because the useCallback will be regenerated and break the debouncing
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateConfig, location.pathname]
  );
  const {
    value: configChartTitle,
    debouncedSetValue: debouncedUpdateChartTitle,
  } = useDebouncedValue(config.chartTitle ?? '', 500, updateChartTitle);

  // this state is needed to control the input field - it is updated with every keystroke
  const [chartTitle, setChartTitle] = useState(configChartTitle);

  return (
    <div className="flex flex-col">
      <SettingTitle title="Panel title" />
      <TextField
        dataTest="media-chart-title-input"
        value={chartTitle}
        onChange={newValue => {
          setChartTitle(newValue);
          // Don't actually update the chart title if the user is deleting the title
          if (newValue !== '') {
            debouncedUpdateChartTitle(newValue);
          }
        }}
      />
    </div>
  );
};
